import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import app from '@devices/settings/device_settings/app';
import { sensor_addon } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import xt1_settings, {
	xt1_default_and_addon_settings,
	xt1_default_settings,
	xt1_device_settings,
	xt1_light_settings,
	xt1_cct_settings,
	xt1_rgb_settings,
	xt1_rgbw_settings,
	xt1_cover_settings,
	xt1_inputs_reader_settings,
} from '@devices/settings/device_settings/xt1_settings';

const moduleSettings = {
	channels: 1,
	ap_ssid: '',
	bt_name: '',
	name: 'Shelly X Device',
};

export default {
	name: 'ShellyXT1',
	friendly_name: 'Shelly X Device',
	family: 'module',
	addons: sensor_addon,
	modes: {
		module: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: xt1_settings,
		},
		'irrigation-controller': {
			channels: 1,
			ap_ssid: 'Irrigation',
			bt_name: 'Irrigation',
			name: 'Irrigation Controller',
			category: 'irrigation',
			dashInfoLabels: 'xt1-irrigation',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				{
					title: 'irrigation_zones_settings',
					components: [
						{
							title: 'irrigation_zones_settings',
							component: 'irrigation_zones_settings',
						},
					],
				},
				{
					title: 'irrigation_sequences',
					components: [
						{
							title: 'irrigation_sequences',
							component: 'irrigation_sequences',
						},
					],
				},
				...xt1_default_settings,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'base_temperature', component: 'base_temperature' },
						{
							title: 'irrigation_enable_weather_api',
							component: 'enable_weather_api',
						},
						{
							title: 'irrigation_duration_offset',
							component: 'irrigation_duration_offset',
						},
						{
							title: 'limit_enabled_zones',
							component: 'limit_enabled_channels',
						},
						...xt1_device_settings.components,
					],
				},
			],
		},
		'simple-water-valve-controller': {
			channels: 1,
			ap_ssid: 'WaterValve',
			bt_name: 'WaterValve',
			name: 'Water Valve',
			category: 'valve',
			dashInfoLabels: 'xt1-valve',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				...xt1_default_and_addon_settings,
				app,
				share,
				{
					title: 'settings',
					components: [
						{
							title: 'valve_action_on_power_restored',
							component: 'valve_action_on_power_restored',
						},
						{
							title: 'valve_action_on_power_lost',
							component: 'valve_action_on_power_lost',
						},
						...xt1_device_settings.components,
					],
				},
			],
		},
		'linkedgo-st1820-floor-thermostat': {
			channels: 1,
			ap_ssid: 'ST-1820',
			bt_name: 'ST1820',
			name: 'Thermostat ST-1820',
			category: 'thermostat',
			dashInfoLabels: 'xt1-thermostat',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				...xt1_default_settings,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'temperature_offset',
							component: 'thermostat_temperature_offset',
						},
						{
							title: 'humidity_offset',
							component: 'thermostat_humidity_offset',
						},
						{
							title: 'temperature_settings',
							component: 'thermostat_temperature_settings',
						},
						{
							title: 'thermostat_hysteresis',
							component: 'thermostat_hysteresis',
						},
						{
							title: 'anti_freeze_temperature',
							component: 'thermostat_anti_freeze_temp',
						},
					],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'kids_protection', component: 'thermostat_child_lock' },
						{ title: 'anti_freeze', component: 'thermostat_anti_freeze' },
						{
							title: 'power_down_memory',
							component: 'thermostat_power_down_memory',
						},
						...xt1_device_settings.components,
					],
				},
			],
		},
		'linkedgo-st-802-hvac': {
			channels: 1,
			ap_ssid: 'ST-802',
			bt_name: 'ST-802',
			name: 'WiFi Multifunction Thermostat ST-802',
			category: 'thermostat',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				...xt1_default_settings,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'temperature_unit',
							component: 'thermostat_temperature_unit',
						},
					],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'anti_freeze', component: 'thermostat_anti_freeze' },
						...xt1_device_settings.components,
					],
				},
			],
		},
		'neo-water-valve-advanced': {
			channels: 1,
			ap_ssid: 'NeoWaterAdv',
			bt_name: 'NeoValve|NeoWater',
			name: 'Neo Smart Water Valve',
			category: 'valve',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				...xt1_default_settings,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'sensor_settings',
							component: 'valve_neo_valve_settings',
						},
					],
				},
				app,
				share,
				xt1_device_settings,
			],
		},
		'heiman-co2-sensor': {
			channels: 1,
			ap_ssid: 'HeimanCO2Sensor',
			bt_name: 'HeimanCO2|AirQuality',
			name: 'Heiman CO2 Sensor',
			category: 'sensor',
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'temperature_unit',
							component: 'thermostat_temperature_unit',
						},
					],
				},
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		'top-evse-charger': {
			channels: 1,
			ap_ssid: 'EvCharger',
			bt_name: 'EvCharger|EVE01',
			name: 'TopacEVSE - EV charger',
			category: 'charger',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				...xt1_default_settings,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'auto_balance', component: 'ev_charger_auto_balance' },
						{ title: 'auto_charge', component: 'ev_charger_auto_charge' },
						{
							title: 'current_global_charge_limit',
							component: 'ev_charger_global_charge_limit',
						},
						{
							title: 'current_global_time_limit',
							component: 'ev_charger_global_time_limit',
						},
						{
							title: 'randomize_delay',
							component: 'ev_charger_randomize_delay',
							min_ver: '2.0.0',
						},
						{
							title: 'insert_handshake',
							component: 'ev_charger_insert_handshake',
							min_ver: '2.0.0',
						},
						{ title: 'device_name', component: 'device_name_sys' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		dehumidifier: {
			channels: 1,
			ap_ssid: 'Boreas20L',
			bt_name: 'Boreas20L',
			name: 'Dehumidifier',
			category: 'dehumidifier',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				{
					title: 'timer',
					icon: 'far fa-clock',
					components: [
						{
							title: 'auto',
							component: 'dehumidifier_auto_off_delay',
						},
					],
				},
				...xt1_settings,
			],
		},
		'window-cover': {
			channels: 1,
			ap_ssid: 'RaexCurtainRails',
			bt_name: 'RaexCurtainRails',
			name: 'RAEX MP46 Curtain motor',
			category: 'cover',
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: xt1_settings,
		},
		light: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: xt1_light_settings,
		},
		cct: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: xt1_cct_settings,
		},
		rgb: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: xt1_rgb_settings,
		},
		rgbw: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			color: true,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: xt1_rgbw_settings,
		},
		roller: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'overpower', 'overtemperature'],
			slider: true,
			settings: xt1_cover_settings,
		},
		inputs_reader: {
			...moduleSettings,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: xt1_inputs_reader_settings,
		},
	},
};
